<template>
  <div
    class="tag-list">
    <span
      v-for="(tag, index) in value"
      :style="getTagStyle(tag)"
      :key="index">
        {{ tag.name }}
    </span>
</div>
</template>

<script>
import chroma from 'chroma-js';

export default {
  name: 'Tags',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getTagStyle (tag) {
      const hash = hashCode(tag.name);
      const percent = hash / 256;
      const scale = chroma.scale(['red', 'green', 'blue']);

      return {
        backgroundColor: scale(percent).alpha(0.8)
      };
    }
  }
};

const hashCode = (text) => {
  let hash = 0;
  if (text.length === 0) return hash;
  for (let i = 0; i < text.length; i++) {
    let chr = text.charCodeAt(i);
    hash = hash * 17 + chr;
  }
  return hash & 255;
};

</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  span {
    padding: $sp-margin-smaller;
    border-radius: 4px;
    color: $white;
    margin-right: $sp-margin-smaller;
  }

  .tag-list {
    line-height: 2;
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/Tags.vue